export const placeholderError = {
  title: [
    'Title is Required',
    'Title length must be greater than 3 and less than 50'
  ],
  message: [
    'Message is Required',
    'Message length must be greater than 3 and less than 2500'
  ]
};
export const queryMsg = {
  unknownError: 'Some Error Occured please try to login after sometime',
  error: 'Error sending query',
  successTitle: 'Message Sent'
};
